import React, { forwardRef } from 'react';

type OwnProps = React.SVGProps<SVGSVGElement>;

const QuestionCircleIcon = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
    ref={ref}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1430_6351)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.32626 8.98578H7.30258C7.1762 8.98578 7.06246 8.88468 7.06246 8.74566V8.21486C7.06246 7.56882 7.5711 7.13867 8.041 6.7413C8.44435 6.4002 8.81914 6.08325 8.81914 5.67462C8.81914 5.21965 8.44 4.82787 7.8081 4.82787C7.21026 4.82787 6.87083 5.12428 6.63068 5.334C6.56115 5.39471 6.49994 5.44816 6.44319 5.48505C6.34209 5.54824 6.25362 5.54824 6.16516 5.47241L5.57117 4.89106C5.47006 4.8026 5.4827 4.65094 5.57117 4.56247C5.57117 4.56247 6.43055 3.45033 8.04822 3.45033C9.37521 3.45033 10.5 4.33499 10.5 5.57351C10.5 6.47084 9.83856 6.99393 9.29193 7.42621C8.90701 7.73062 8.57902 7.99 8.57902 8.30333V8.72038C8.57902 8.87204 8.49055 8.98578 8.32626 8.98578ZM7.8081 12.5497C7.23939 12.5497 6.77178 12.0821 6.77178 11.5134C6.77178 10.9447 7.23939 10.4644 7.8081 10.4644C8.37681 10.4644 8.85706 10.9447 8.85706 11.5134C8.85706 12.0821 8.37681 12.5497 7.8081 12.5497Z"
        fill="#6D7184"
      />
    </g>
    <defs>
      <clipPath id="clip0_1430_6351">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
));

export default QuestionCircleIcon;
